<div class="py-2">
  <div
    class="is-flex is-justify-content-space-between px-3"
    [ngClass]="{ 'is-flex-wrap-wrap': isSmall }"
  >
    <div class="pr-2">
      <label class="label" for="dpFromDate">
        <span data-e2e="title-start-date" i18n>Start</span>
      </label>
      <p class="control is-expanded">
        <input
          class="input"
          name="dpFromDate"
          id="dpFromDate"
          [placeholder]="dateFormat"
          data-e2e="input-from-date"
          [value]="fromDateValue"
          (keyup)="onFromDateChange($event)"
          (blur)="onFromDateChange($event)"
          [ngClass]="{ 'is-danger': fromDateErrorMessages.length > 0 }"
          aria-label="Start date"
          i18n-aria-label
        />
      </p>
      <div class="help has-text-grey-darker">
        <span *ngIf="!fromDateErrorMessages.length">{{ dateFormat }}</span>
        <span class="help is-danger" *ngIf="fromDateErrorMessages.length > 0">
          <p data-e2e="error-date-filter-from-date">{{ fromDateErrorMessages[0] }}</p>
        </span>
      </div>
    </div>
    <div>
      <label class="label" for="dpToDate">
        <span data-e2e="title-end-date" i18n>End</span>
      </label>
      <p class="control is-expanded">
        <input
          class="input"
          name="dpToDate"
          id="dpToDate"
          data-e2e="input-to-date"
          [placeholder]="dateFormat"
          [value]="toDateValue"
          (keyup)="onToDateChange($event)"
          (blur)="onToDateChange($event)"
          [ngClass]="{ 'is-danger': toDateErrorMessages.length > 0 }"
          aria-label="End date"
          i18n-aria-label
        />
      </p>
      <div class="help has-text-grey-darker">
        <span *ngIf="!toDateErrorMessages.length">{{ dateFormat }}</span>
        <span class="help is-danger" *ngIf="toDateErrorMessages.length > 0">
          <p data-e2e="error-date-filter-to-date">{{ toDateErrorMessages[0] }}</p>
        </span>
      </div>
    </div>
  </div>
  <div *ngIf="showQuickPicks" class="field pb-1 pt-3 px-3">
    <div id="quickpick-dropdown" class="dropdown mb-2" #quickPickDropdown>
      <div class="dropdown-trigger">
        <button
          class="button"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          (click)="toggleDropDown($event)"
          (keydown.enter)="toggleDropDown($event)"
          title="{{ quickPickButtonText || 'Selection presets' }}"
          i18n-title
        >
          <span i18n>{{ quickPickButtonText || 'Selection presets' }}</span>
          <span class="icon">
            <i class="fas fa-chevron-down" aria-hidden="true"></i>
            <i class="fas fa-chevron-up is-hidden" aria-hidden="true"></i>
          </span>
        </button>
      </div>
      <div *ngIf="isQuickPickOpen" class="dropdown-menu" id="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <div *ngFor="let quickPick of quickPicksList">
            <a
              tabindex="0"
              class="dropdown-item py-2"
              attr.data-e2e="{{ quickPick.id }}-quick-pick-option"
              [ngClass]="{ 'is-active': selectedQuickPick === quickPick.id }"
              (click)="onQuickPickSelect(quickPick)"
              (keydown.enter)="onQuickPickSelect(quickPick)"
              title="{{ quickPick.text }}"
            >
              <span>{{ quickPick.text }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="py-1 has-border-bottom" [class.px-3]="!isSmall">
  <ngb-datepicker
    #dp
    (dateSelect)="onDateSelection($event)"
    [displayMonths]="1"
    [dayTemplate]="t"
    [maxDate]="maxDate"
    [startDate]="_dateToShow"
    [markDisabled]="markDisabled"
    outsideDays="hidden"
  >
  </ngb-datepicker>
</div>

<div
  *ngIf="showTimePicker"
  class="columns"
  [ngClass]="{ 'disable-time-picker': disableTimePicker }"
>
  <ngb-timepicker
    #fromTimePicker
    [ngModel]="_fromTime"
    (ngModelChange)="fromTimeChange($event)"
    [disabled]="disableTimePicker"
    (click)="selectText($event)"
    class="ngb-time-input column is-6"
  ></ngb-timepicker>

  <ngb-timepicker
    #toTimePicker
    [ngModel]="_toTime"
    (ngModelChange)="toTimeChange($event)"
    [disabled]="disableTimePicker"
    (click)="selectText($event)"
    class="ngb-time-input column is-6"
  ></ngb-timepicker>
</div>

<div *ngIf="invalidTime" class="has-border-top help px-3 has-text-centered margin-fix">
  <span class="help is-danger is-centered">
    <p data-e2e="error-date-filter-from-date">
      The selected time duration must be same as under date range.
    </p>
  </span>
</div>

<ng-template #t let-date let-focused="focused">
  <div
    class="custom-day"
    [class.focused]="focused"
    [class.first]="isFirst(date)"
    [class.last]="isLast(date)"
    [class.range]="isRange(date)"
    [class.faded]="isHovered(date) || isInside(date)"
    [class.has-text-dark]="!markDisabled?.(date)"
    (mouseenter)="hoveredDate = date"
    (mouseleave)="hoveredDate = null"
  >
    {{ date.day }}
  </div>
</ng-template>
